/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  FormulaResponseDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FormulaResponseDtoFromJSON,
    FormulaResponseDtoToJSON,
} from '../models/index';

export interface InternalGetFormulaByIdRequest {
    formulaId: number;
}

/**
 * 
 */
export class InternalSupplementProviderApi extends runtime.BaseAPI {

    /**
     * Fetches detailed formula information including materials/supplements for instruction generation. This is an internal endpoint used by cloud functions for service-to-service communication.
     * Get formula details by ID (Internal)
     */
    async internalGetFormulaByIdRaw(requestParameters: InternalGetFormulaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormulaResponseDto>> {
        if (requestParameters['formulaId'] == null) {
            throw new runtime.RequiredError(
                'formulaId',
                'Required parameter "formulaId" was null or undefined when calling internalGetFormulaById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key authentication
        }

        const response = await this.request({
            path: `/providers/supplements/formulas/{formulaId}`.replace(`{${"formulaId"}}`, encodeURIComponent(String(requestParameters['formulaId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FormulaResponseDtoFromJSON(jsonValue));
    }

    /**
     * Fetches detailed formula information including materials/supplements for instruction generation. This is an internal endpoint used by cloud functions for service-to-service communication.
     * Get formula details by ID (Internal)
     */
    async internalGetFormulaById(requestParameters: InternalGetFormulaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormulaResponseDto> {
        const response = await this.internalGetFormulaByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
